var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
          'pp-ui-button': _vm.applyStyles,
          'pp-ui-hidden': !_vm.chromecast.canCast,
          'pp-ui-no-interaction': _vm.chromecast.startCasting || _vm.chromecast.stopCasting,
        },on:{"click":_vm.onClick}},[_vm._t("default",function(){return [(_vm.chromecast.isCasting)?_c('CastConnected'):(_vm.chromecast.canCast)?_c('Cast'):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }